export default __webpack_public_path__ + "static/media/buttons-card-1-active.c896b1b3.svg";